import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { AppStore } from '../redux/store';
import { PublicRoutes, PrivateRoutes } from '../models/routes';
import { decodeOperatorJWT } from '../services/auth.service';

interface Props {
  privateValidation: boolean;
}

const PrivateValidationFragment = <Outlet />;
const PublicValidationFragment = <Navigate replace to={PrivateRoutes.DASHBOARD} />;

export const AuthGuard = ({ privateValidation }: Props) => {
  const userState = useSelector((store: AppStore) => store.user);
  const tokenStore = useSelector((store:AppStore) => store.token);
  const navigate = useNavigate();

useEffect(() => {
    if(tokenStore && tokenStore?.token) {
      const userDecode = decodeOperatorJWT(tokenStore.token)
      const validToken = userDecode.exp !== undefined ? ((userDecode.exp) > (Math.floor(new Date().getTime()/1000.0))) : false
        if(!validToken){
          navigate(`/${PublicRoutes.LOGIN}`, {replace:true})
        }
    }  
  },[])

  return userState?.id ? (
    privateValidation ? (
      PrivateValidationFragment
    ) : (
      PublicValidationFragment
    )
  ) : (
    <Navigate replace to={PublicRoutes.LOGIN} />
  );
};

export default AuthGuard;
